import { useIsDesktopDevice } from '../../tools/hooks/useIsDesktopDevice.ts';
import AdministrationDesktopView from './desktop/Administration.desktop.view.tsx';

export default function AdministrationView() {
  const isDesktop = useIsDesktopDevice();

  return <>{isDesktop && <AdministrationDesktopView />}</>;
}
